import { CommonModule } from '@angular/common'
import {
    Component,
    HostListener,
    inject,
    input,
    signal,
    ChangeDetectionStrategy,
} from '@angular/core'
import { FormsModule } from '@angular/forms'
import { Router } from '@angular/router'
import { AuthStateService } from '@baboor/baboor-auth'
import { LanguageService } from '@baboor/baboor-language'
import { UserSettingsApiService } from '@baboor/baboor-user-setting'
import { ThemeService } from '@baboor/common-services'
import { take } from 'rxjs'
@Component({
    selector: 'app-header-quick-settings',
    imports: [CommonModule, FormsModule],
    templateUrl: './header-quick-settings.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './header-quick-settings.component.css',
})
export class HeaderQuickSettingsComponent {
    private router = inject(Router)
    private themeService = inject(ThemeService)
    private userSettingsApiService = inject(UserSettingsApiService)
    readonly languageService = inject(LanguageService)
    readonly authStateService = inject(AuthStateService)
    readonly isQuickSettingsDropdownVisible = signal(false)
    readonly isEasyMode = input(false)

    themeChecked = this.themeService.isDark

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent) {
        const target = event.target as HTMLElement
        if (!target.closest('.quick-settings-wrapper')) {
            this.isQuickSettingsDropdownVisible.set(false)
        }
    }

    toggleQuickSettingsDropdown(): void {
        this.isQuickSettingsDropdownVisible.update((value) => !value)
    }

    toggleTheme(): void {
        this.themeChecked = !this.themeChecked
        this.onThemeChange()
    }

    private onThemeChange(): void {
        this.themeService.setTheme(this.themeChecked)
        const theme = this.themeChecked ? 'dark' : 'light'
        const userId = this.authStateService.getUserId()
        if (!userId) return
        this.userSettingsApiService
            .updateUserSetting(userId, { theme })
            .pipe(take(1))
            .subscribe()
    }

    goToEasyMode(): void {
        this.isQuickSettingsDropdownVisible.set(false)
        if (this.isEasyMode()) {
            this.router.navigate(['/dashboard/home'])
            return
        }
        this.router.navigate(['/easy/dashboard/home'])
    }

    onSelectLanguage(lang: string): void {
        this.languageService.selectLanguage(lang)
        this.isQuickSettingsDropdownVisible.set(false)
    }
}
